/**
 * Entities Store Module
 * Type-safe Vuex module for normalized entity storage
 *
 * ✅ FULLY TYPESCRIPT with DTOs!
 * - All files now .ts with proper types
 * - Uses HomeService for API calls
 * - DTOs validate at API boundary
 * - Type-safe getters, mutations, actions
 */

import { Module } from 'vuex';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';
import createState from './state';
import { EntitiesState } from './types';

const entitiesModule: Module<EntitiesState, any> = {
  namespaced: true,
  state: createState,
  mutations,
  getters,
  actions,
};

export default entitiesModule;

// Export types for use in components
export type { EntitiesState } from './types';
export type {
  HomeEntity,
  RoomEntity,
  DeviceEntity,
  GatewayEntity,
  Relationships,
  NormalizedData,
} from './types';
